import { node } from 'prop-types';

import AuthFormRow from 'modules/auth/shared/components/form/row';

import './error.scss';

function AuthFormError({ children }) {
  return (
    <AuthFormRow center>
      <div className="AuthFormError alk-flex">
        <i className="mdi mdi-alert" />
        <span className="AuthFormError__children alk-flex">{children}</span>
      </div>
    </AuthFormRow>
  );
}

AuthFormError.propTypes = {
  children: node,
};

export default AuthFormError;
